var BufferFormatter = require('bufferformatter');
var IRCFormatter = require('ircformatter');


var BufferNotificationHandler = Backbone.View.extend({
    initialize: function (options) {
        this.bindMessageHandlers();
        this.model.bind('unseenHighlightChange', this.unseenHighlightChange, this);
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        for (var type in this.messages) {
            this.model.bind('notableMessage:' + type, this.handleMessage, this);
        }
    },
    shouldNotify: function (message) {
        if (!this.model.session.isInitialized()) {
            return false;
        }
        // Don't notify if this buffer is selected and the window has focus
        // unless it's below the bottom seen
        if (!this.model.isBelowBottomSeen(message) &&
            this.model.isSelected() &&
            this.model.session.isFocused()) {
            return false;
        }
        return true;
    },
    handleMessage: function (message) {
        if (this.shouldNotify(message)) {
            this.messages[message.get('type')].call(this, message);
        }
    },
    messages: {
        buffer_msg: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        buffer_me_msg: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        notice: function (message) {
            var title = message.getDisplayName() + ' — ';
            if (this.model.isChannel()) {
                title += this.model.getDisplayName();
            } else {
                title += this.model.connection.getDisplayName();
            }
            
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        },
        channel_invite: function (message) {
            var title = 'Channel invite from: ' + message.getDisplayName() + ' (' + this.model.connection.getDisplayName() + ')';
            
            var content = IRCFormatter.strip("Invite to join " + message.get('channel'));
            this.notify(message, title, content);
        },
        callerid: function (message) {
            var title = 'Callerid: ' + message.get('nick') + ' (' + this.model.connection.getDisplayName() + ')';
            
            var content = IRCFormatter.strip(message.get('nick') + ' ' + message.get('msg'));
            this.notify(message, title, content);
        },
        wallops: function (message) {
            var title = message.getDisplayName() + ' (' + this.model.connection.getDisplayName() + ')';
            var content = IRCFormatter.strip(message.get('msg'));
            this.notify(message, title, content);
        }
    },
    close: function () {
        if (this.notification) {
            this.notification.close();
            // Close handlers don't work in Safari
            this.notification = null;
        }
    },
    notify: function (message, title, body) {
        if (!this.model.session.getPref('emoji-disableconvert')) {
            body = emoji.replace_colons(body, true);
        }

        var options = {
            model: message,
            tag: this.model.getId(),
            title: title,
            body: body,
            show: _.bind(function (notification) {
                this.notification = notification;
            }, this),
            close: _.bind(function (notification) {
                // Won't work in Safari
                this.notification = null;
            }, this),
            click: _.bind(function (notification) {
                // Won't work in Safari
                // Select buffer and scroll to row
                this.model.select();
                if (!this.model.isDeferred()) {
                    message.show();
                }
                // Focus window
                window.focus();
            }, this)
        };
        options.image = this.formatter.linker.singleImage(message, {
            files: this.model.inlineFilesAllowed(),
            images: this.model.inlineImagesAllowed()
        });
        this.model.session.trigger('notify', this.model, options);
    },
    unseenHighlightChange: function () {
        if (!this.model.hasUnseenHighlights()) {
            this.close();
        }
    }
});


module.exports = BufferNotificationHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/buffernotificationhandler.js
// module id = LKWs
// module chunks = 1